
import { singleton, ofArray, empty } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Requests_ApiReceiverFormDto_$reflection, ApiReceiver_$reflection, Requests_ApiReceiverFormDto } from "../../../../Shared/User.js";
import { FormState__setValidationResponse_5219762A, BusinessUnitId__get_unwrap, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getAccountSettings } from "../../../../Requests/Customer.js";
import { getResponsibleBusinessUnits } from "../../../../Requests/BusinessUnit.js";
import { Cmd_OfPromise_either } from "../../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../../../Communication.js";
import { Types_RequestProperties } from "../../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { isNullOrEmpty, concat } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrapUserId } from "../../../../Shared/Helper.js";
import { map } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../../../CommunicationV2.js";
import { string_type } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../../Components/Toast.js";
import { Cmd_ofEffect } from "../../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export const emptyApiReceiver = new Requests_ApiReceiverFormDto("", "", empty(), undefined, empty(), undefined);

export const initialState = new State(undefined, new RequestedValue$1(0, []), FormState_get_empty(), new RequestedValue$1(0, []), new RequestedValue$1(0, []));

export function initNew() {
    return [new State(initialState.ApiReceiverId, new RequestedValue$1(1, [emptyApiReceiver]), initialState.FormState, initialState.BusinessUnits, initialState.AccountSettings), Cmd_batch(ofArray([getAccountSettings((Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(9, [Item_1]))), getResponsibleBusinessUnits((Item_2) => (new Msg(8, [Item_2])), (Item_3) => (new Msg(9, [Item_3])))]))];
}

export function initEdit(apiReceiverId) {
    return [initialState, Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), ApiReceiver_$reflection()));
    })))), concat("/api/receivers/api-receivers/", ...unwrapUserId(apiReceiverId)), (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(9, [Item_1]))), getAccountSettings((Item_2) => (new Msg(7, [Item_2])), (Item_3) => (new Msg(9, [Item_3]))), getResponsibleBusinessUnits((Item_4) => (new Msg(8, [Item_4])), (Item_5) => (new Msg(9, [Item_5])))]))];
}

export function update(msg, state) {
    let body_3, xs;
    switch (msg.tag) {
        case 1: {
            const email = msg.fields[0];
            const matchValue_1 = state.Form;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const apiReceiver_1 = matchValue_1.fields[0];
                return [new State(state.ApiReceiverId, new RequestedValue$1(1, [new Requests_ApiReceiverFormDto(apiReceiver_1.Name, apiReceiver_1.ImageUrl, apiReceiver_1.QRCodeIds, isNullOrEmpty(email.trim()) ? undefined : email, apiReceiver_1.CustomProperties, apiReceiver_1.BusinessUnitId)]), state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
        }
        case 2: {
            const matchValue_2 = state.Form;
            if (matchValue_2.tag === 1) {
                const apiReceiver_2 = matchValue_2.fields[0];
                return [new State(state.ApiReceiverId, new RequestedValue$1(1, [new Requests_ApiReceiverFormDto(apiReceiver_2.Name, apiReceiver_2.ImageUrl, apiReceiver_2.QRCodeIds, apiReceiver_2.Email, apiReceiver_2.CustomProperties, map((businessUnit_1) => businessUnit_1.value.Id, msg.fields[0]))]), state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 3: {
            const matchValue_3 = state.Form;
            if (matchValue_3.tag === 1) {
                return [new State(state.ApiReceiverId, state.Form, FormState__startLoading(state.FormState), state.BusinessUnits, state.AccountSettings), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix_1(tupledArg[0]), (refreshOn) => fetchWithDecoder_1(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), ["/api/receivers/api-receivers", toString(0, Auto_generateBoxedEncoder_437914C6(Requests_ApiReceiverFormDto_$reflection(), undefined, undefined, undefined)(matchValue_3.fields[0]))], (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(9, [Item_1])))];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 4: {
            const matchValue_4 = state.ApiReceiverId;
            const matchValue_5 = state.Form;
            let matchResult, apiReceiver_5, apiReceiverId;
            if (matchValue_4 != null) {
                if (matchValue_5.tag === 1) {
                    matchResult = 1;
                    apiReceiver_5 = matchValue_5.fields[0];
                    apiReceiverId = matchValue_4;
                }
                else {
                    matchResult = 0;
                }
            }
            else {
                matchResult = 0;
            }
            switch (matchResult) {
                case 0:
                    return [state, Cmd_none()];
                default:
                    return [new State(state.ApiReceiverId, state.Form, FormState__startLoading(state.FormState), state.BusinessUnits, state.AccountSettings), (body_3 = toString(0, Auto_generateBoxedEncoder_437914C6(Requests_ApiReceiverFormDto_$reflection(), undefined, undefined, undefined)(apiReceiver_5)), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix_1(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder_1(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_1) => {
                            const pr_1 = response_1.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                        }, refreshOn_1)))(true);
                    })), [concat("/api/receivers/api-receivers/", ...apiReceiverId), body_3], (Item_2) => (new Msg(6, [Item_2])), (Item_3) => (new Msg(9, [Item_3]))))];
            }
        }
        case 5: {
            const apiReceiver_7 = msg.fields[0];
            return [new State(apiReceiver_7.Id, new RequestedValue$1(1, [new Requests_ApiReceiverFormDto(apiReceiver_7.Name, apiReceiver_7.ImageUrl, apiReceiver_7.QRCodeIds, apiReceiver_7.Email, empty(), map(BusinessUnitId__get_unwrap, apiReceiver_7.BusinessUnitId))]), state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
        }
        case 6: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.ApiReceiverId, state.Form, FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.BusinessUnits, state.AccountSettings), Cmd_errorToast("validation.toast")];
            }
            else {
                return [state, Cmd_batch([(xs = ["settings", "user-management", "api", response_2.fields[0]], Cmd_ofEffect((_arg_1) => {
                    RouterModule_nav(ofArray(xs), 1, 1);
                })), Cmd_successToast("general.saved_successfully")])];
            }
        }
        case 7:
            return [new State(state.ApiReceiverId, state.Form, state.FormState, state.BusinessUnits, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 8:
            return [new State(state.ApiReceiverId, state.Form, state.FormState, new RequestedValue$1(1, [msg.fields[0]]), state.AccountSettings), Cmd_none()];
        case 9:
            return [state, Cmd_none()];
        default: {
            const matchValue = state.Form;
            if (matchValue.tag === 1) {
                const apiReceiver = matchValue.fields[0];
                return [new State(state.ApiReceiverId, new RequestedValue$1(1, [new Requests_ApiReceiverFormDto(msg.fields[0], apiReceiver.ImageUrl, apiReceiver.QRCodeIds, apiReceiver.Email, apiReceiver.CustomProperties, apiReceiver.BusinessUnitId)]), state.FormState, state.BusinessUnits, state.AccountSettings), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
    }
}

